import Information from './models/Information'
import { fetchShopInformation as fetchShopInformationFromServer } from './api'
import ChannelManager from '../channel-manager'

export default class ShopInformationManager {
  private static _manager: ShopInformationManager
  private channelManager: ChannelManager

  static instance(): ShopInformationManager {
    if (this._manager === undefined) {
      this._manager = new ShopInformationManager()
    }

    return this._manager
  }

  private _informationMap: Map<string, Information>

  private constructor() {
    this._informationMap = new Map<string, Information>()
    this.channelManager = ChannelManager.instance()
  }

  /**
   * 将店铺渠道信息存储到ChannelManager
   */
  private storeChannelsIfNeeded(shopId: string, information: Information): void {
    if (information.channels && information.channels.length > 0) {
      this.channelManager.setShopChannels(shopId, information.channels)
    }
  }

  async fetchShopInformation(
    shopId: string,
    forceFetch = false
  ): Promise<Information> {
    const information = this._informationMap.get(shopId)

    if (information === undefined || forceFetch) {
      try {
        const { data } = await fetchShopInformationFromServer(shopId)
        this._informationMap.set(shopId, data)
        // 存储channels信息
        this.storeChannelsIfNeeded(shopId, data)
        return Promise.resolve(data)
      } catch (e) {
        return Promise.reject(e)
      }
    }
    // 添加debug日志参数
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    const _debugRemark = window._debugRemark
    const restaurantName = information?.information?.restaurantName
    if (restaurantName && _debugRemark instanceof Map && !_debugRemark.has('shopName')) {
      _debugRemark.set('shopName', restaurantName)
    }
    // 确保channels信息被存储（缓存场景）
    this.storeChannelsIfNeeded(shopId, information)
    return Promise.resolve(information)
  }
}
